// extracted by mini-css-extract-plugin
export default {"projects":"Work_projects__neMy+","tech":"Work_tech__3qItH"};